// API каталога техники.
// Данными управляет админка (lcstonexxi/api_v2/admin), публичный метод — api_v2/api/catalog.
// Ответы сервера уже в формате { status, ... }, поэтому отдаются как есть.

import { postApi, postUrl } from '@/run'

const url = '//lc.stone-xxi.ru/api_v2/api/catalog'

// Страница каталога: params — { type: 'new' | 'used', rows, limit, offset },
// ответ — { status, total, data }
const getCatalog = async (params) => {
    return await postUrl(url, params)
}

// Всё для первого экрана одним запросом: сочетания для селектов
// и первые страницы обеих групп — { status, filters, new, used }
const getCatalogInit = async (limit) => {
    return await postUrl(url, { action: 'init', limit })
}

// Выдача по фильтру rows одним запросом: счётчики и первые страницы
// обеих групп — { status, total, new: { total, data }, used: { total, data } }
const getCatalogSearch = async (rows, limit) => {
    return await postUrl(url, { action: 'search', rows, limit })
}

// Одна позиция по id
const getCatalogItem = async (id) => {
    return await postUrl(url, { id: Number(id) })
}

// Оформление заявки из каталога авторизованным пользователем: на бэке ЛК
// (GitLkApi) по параметрам позиции (наименование, тип ПЛ, марка, модель, цена, валюта,
// ИНН поставщика) считается расчёт и создаётся лизинг для предприятия.
// По SupplierINN calc-сервис находит поставщика в базе (при отсутствии — создаёт).
// Ответ — { status, leasingId } либо { error }
const createCatalogApplication = async (item) => {
    return await postApi('/catalog/request', {
        LeasingSubjectName: item.name,
        LeasingSubjectType: item.leasing_subject_type,
        LeasingSubjectBrand: item.brand,
        LeasingSubjectModel: item.model,
        LeasingSubjectPriceBase: item.price,
        LeasingSubjectPriceCurrency: item.currency,
        SupplierINN: item.supplier_inn
    })
}

export { getCatalog, getCatalogInit, getCatalogSearch, getCatalogItem, createCatalogApplication }
